import React from "react";
import { Avatar, Box } from "@mui/material";
import Typography from "component/MarketPlace/Typography";
import { getAvatarName } from "utils/functions";

export interface IContentDescription {
  label: string;
  name: string;
}

const ContentDescription = (props: IContentDescription) => {
  const { label, name } = props;
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection={{ xs: "row", sm: "row", md: "column" }}
      padding="0 10px"
    >
      <Typography width={{xs: "72px", md: 'unset'}} marginRight="10px" variant="overline" color="text.secondary" id="lbl-contentdescription-label">
        {label}
      </Typography>
      <Box
        display="flex"
        alignItems="center"
        justifyContent={{ xs: 'flex-start', sm: 'flex-start', md: 'center' }}
        gap="0 10px"
        width={{ xs: "150px", sm: "180px", md: '200px' }}
      >
        <Avatar sx={{ width: "24px", height: "24px" }} variant="circular">
          <Typography fontSize="12px" id="lbl-contentdescription-avatar">{getAvatarName(name)}</Typography>
        </Avatar>
        <Typography noWrap variant="body2" color="text.secondary" id="lbl-contentdescription-name">
          {name}
        </Typography>
      </Box>
    </Box>
  );
};
export default ContentDescription;
